import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.382 15.2H1.618a1 1 0 0 1-.894-1.447L7.106.989a1 1 0 0 1 1.788 0l6.382 12.764a1 1 0 0 1-.894 1.447ZM7.2 4v6.4h1.6V4H7.2Zm0 8v1.6h1.6V12H7.2Z",
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-warning-triangle"}) } }